module.exports = require("goingutils");


//////////////////
// WEBPACK FOOTER
// external "goingutils"
// module id = 0
// module chunks = 0